import { useLocation, useParams } from 'react-router';
import { z } from 'zod';

import { RouteParamsValidationException } from '../routes/RouteParamsValidationException';

/**
 * Parses path parameters according to provided ZOD schema.
 *
 * Example:
 *
 * const schema = z.object({ id: z.string().pipe(z.coerce.number()) });
 *
 * const { id } = useTypedPathParams(schema);
 *
 *
 * @param schema
 * @returns schema
 */
export const useTypedPathParams = <Output, Def extends z.ZodTypeDef, Input>(schema: z.Schema<Output, Def, Input>): Output => {
	const pathParams = useParams();
	const { pathname } = useLocation();

	try {
		const parsedSearchParams = schema.parse(pathParams);
		return parsedSearchParams;
	} catch (error) {
		if (error instanceof z.ZodError) {
			throw new RouteParamsValidationException(error.message, pathname);
		}
		throw error;
	}
};
